<template lang="pug">

  .SearchSideFooter
    .SearchSideFooter_wrapper
      div.SearchSideFooter_filtersBtnContent
        ButtonSimple.SearchSideFooter_filtersBtn(@click.native.prevent="deploy", :class="deployState && 'deploy'")
            span.SearchSideFooter_filtersBtnLabel {{ $t('search.filters') }}
            SvgInline(src="arrow-deploy").SearchSideFooter_resetBtnIcon
      p.SearchSideFooter_results
        span.SearchSideFooter_resultsCount {{ totalResults }}
        span.SearchSideFooter_resultsLabel {{ $tc('search.results', totalResults, { count: totalResults }) }}
      transition(name="reset")
        ButtonSimple.SearchSideFooter_resetBtn(v-if="hasFilters", @click.native.prevent="clear")
          SvgInline(src="cross").SearchSideFooter_resetBtnIcon
          span.SearchSideFooter_resetBtnLabel {{ $t('search.clear') }}

</template>

<script>

import { Component } from 'vue-instantsearch'
import ButtonSimple from '@/components/common/ButtonSimple'
import SvgInline from '@/components/SvgInline'
import { mapGetters } from 'vuex'

export default {
  mixins: [Component],
  components: { ButtonSimple, SvgInline },
  props: {
    deployState: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(['nbItemDisplay']),
    totalResults () {
      return this.searchStore.totalResults
    },
    hasFilters () {
      const activeFilter = this.searchStore.activeRefinements.filter(x => x.attributeName !== 'lat' && x.attributeName !== 'lng')
      return this.searchStore.query.length > 0 || activeFilter.length > 0
    }
  },
  methods: {
    clear () {
      this.searchStore.stop()
      if (this.searchStore.query.length > 0) {
        this.searchStore.query = ''
      }
      if (this.searchStore.activeRefinements.length > 0) {
        this.searchStore.activeRefinements.forEach(ref => {
          if (ref.attributeName !== 'lat' && ref.attributeName !== 'lng') {
            this.searchStore.clearRefinements(ref.attributeName)
          }
        })
      }
      this.searchStore.start()
      this.searchStore.refresh()
    },
    deploy () {
      this.$emit('deployTrigger', !this.deployState)
    }
  }
}
</script>

<style lang="stylus" scoped>

.SearchSideFooter
  box-sizing: border-box
  position: absolute
  bottom: 0
  right: 0
  left 0
  background-color $grey-1
  background-image url('/img/backgrounds/grey1_grain_background.jpg')
  background-position 50%
  background-repeat repeat

  &::before
    content ''
    position: absolute
    top 0
    left 0
    right 0
    bottom 0
    background-repeat no-repeat
    background-position 50% 40%
    opacity: .3

  .reset-enter,
  .reset-leave-to
    opacity: 0
    transform translate(20px, 0)

  .reset-enter-active,
  .reset-leave-active
    transition all .8s $ease

  &_wrapper
    box-sizing: border-box
    position: relative
    height 110px
    display: flex
    justify-content space-between
    align-items: center
    padding 20px 40px

    @media $mq_s_only
      justify-content left
      height 60px
    padding 20px 20px

  &_results
    color $beige
    margin-left 10px

  &_resultsCount
    display: block
    font-size 40px
    line-height: @font-size

    @media $mq_m

      font-size 30px
      line-height 30px

    @media $mq_s_only

      font-size 30px
      line-height 30px

  &_resultsLabel
    display: block
    font-size 12px
    line-height: @font-size
    opacity: .3
    margin-top 10px
    text-transform uppercase

    @media $mq_m

      margin-top 0px

    @media $mq_s_only

      margin-top 0px

  &_resetBtn
    margin 0
    background-color $black
    border-color: $black
    color $beige
    text-transform none
    text-decoration underline
    margin-left 20px

    padding 0px 20px

    @media $mq_m_only

      padding 0px 20px

      svg

        margin 0px!important
        margin-bottom -2px!important

      span

        display none

    @media $mq_s_only

      padding 0px 20px

      svg

        margin 0px!important
        margin-bottom -2px!important

      span

        display none

    &:hover
      background-color $beige
      border-color: $beige
      color $black

      .SearchSideFooter_resetBtnIcon
        transform rotateZ(-90deg)

  &_resetBtnIcon
    margin: 0 15px -2px 0 !important
    display: inline-block
    transform rotateZ(0deg)
    transition transform .8s $ease

  &_filtersBtnContent
    flex: 1;
    margin-left: 30px;
    display none

    @media $mq_s_only
      display block

  &_filtersBtn
    background $beige
    color $black
    height 40px
    line-height 40px
    padding 0 20px
    margin 0

    svg
      fill $black
      width 18px
      vertical-align middle
      position relative
      top -2px
      margin 0 !important
      padding 0px

    &.deploy

      svg
        transform rotate(180deg)

    &:hover
      color $beige

      svg
        fill $beige

      &::before
        background $black

  &_filtersBtnLabel
    margin-right 5px
    display inline-block

</style>
